/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import DialogContent from '@mui/material/DialogContent';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { ToastContainer, toast } from 'react-toastify';
import { useQuery, useMutation } from '@apollo/client';
import * as Q from '../../../../constants/graphqlQueries';
import ModalDetail from '../../../ModalDetail/ModalDetail';
import UserRoles from '../../../../constants/userRoles';
import transactionResponse from '../../../../constants/transactionResponse';

import './AdminManage.css';
import AdminTable from './AdminTable';
import CustomButtons from '../../../components/Button/CustomButtons';

// Constants
const CMPermissionTypes = [
    { id: 1, name: 'Create', ruleType: [ {id: 1, status: false, type: 'Enterprise'} ] },
    { id: 2, name: 'Edit', ruleType: [ {id: 1, status: false, type: 'Enterprise'} ] },
    { id: 3, name: 'Delete', ruleType: [ {id: 1, status: false, type: 'Enterprise'} ] },
    { id: 4, name: 'Search', ruleType: [ {id: 1, status: false, type: 'Enterprise'} ] },
  ];
const RCPermissionTypes = [
    { id: 1, name: 'Create', ruleType: [ {id: 1, status: false, type: 'Enterprise'}, {id: 2, status: false, type: 'Custom'} ] },
    { id: 2, name: 'Edit', ruleType: [ {id: 1, status: false, type: 'Enterprise'}, {id: 2, status: false, type: 'Custom'} ] },
    { id: 3, name: 'Delete', ruleType: [ {id: 1, status: false, type: 'Enterprise'}, {id: 2, status: false, type: 'Custom'} ] },
    { id: 4, name: 'Search', ruleType: [ {id: 1, status: false, type: 'Enterprise'}, {id: 2, status: false, type: 'Custom'} ] },
    { id: 5, name: 'Activate/Pause', ruleType: [ {id: 1, status: false, type: 'Enterprise'}, {id: 2, status: false, type: 'Custom'} ] }
  ];
const CodeMappingLabels = {
  title: 'Code Mapping',
  subTitle: [{ id: 1, name: 'Enterprise' }]
};
const RuleConfigurationLabels = {
  title: 'Rules Configuration',
  subTitle: [{ id: 1, name: 'Enterprise' }, { id: 2, name: 'Custom' }]
};
const transactionMessages = {
  moduleName: 'Role Permissions',
};

const RolePermissions = () => {
  const [open, setOpen] = useState(false);
  const [selectedRole] = useState(UserRoles.WFM);
  const [saveDisabled, setSaveDisabled] = useState(false);

  const { data: dataRolePermissions, loading: isLoading } = useQuery(Q.ADMIN_MANAGEMENT_ROLE_PERMISSIONS,
    {
      variables: { selectedRole },
    });
  const [updateRoleActionPermission, { data: dataRoleActionPermissionUpdate }] = useMutation(
    Q.ADMIN_MANAGEMENT_ROLE_PERMISSIONS_MUTATION,
    {
      onError: (error) => {
        toast(error.message);
        setSaveDisabled(false);
      },
    },
  );
  const [codeMappingSwitches, setCodeMappingSwitches] = useState(CMPermissionTypes);

  const [rulesConfigurationSwitches, setRulesConfigurationSwitches] = useState(RCPermissionTypes);

  const modalOptions = {
    title: 'Data not found',
    description: 'Please make another search',
  };

  const handleSave = () => {
    setSaveDisabled(true);
    updateRoleActionPermission({
      variables: {
        selectedRole,
        codeMappingEnterpriseCreate: codeMappingSwitches[0].ruleType[0].status,
        codeMappingEnterpriseEdit: codeMappingSwitches[1].ruleType[0].status,
        codeMappingEnterpriseDelete: codeMappingSwitches[2].ruleType[0].status,
        codeMappingEnterpriseSearch: codeMappingSwitches[3].ruleType[0].status,

        rulesConfigurationEnterpriseCreate: rulesConfigurationSwitches[0].ruleType[0].status,
        rulesConfigurationEnterpriseEdit: rulesConfigurationSwitches[1].ruleType[0].status,
        rulesConfigurationEnterpriseDelete: rulesConfigurationSwitches[2].ruleType[0].status,
        rulesConfigurationEnterpriseSearch: rulesConfigurationSwitches[3].ruleType[0].status,
        RulesConfigurationEnterpriseActive: rulesConfigurationSwitches[4].ruleType[0].status,

        rulesConfigurationCustomCreate: rulesConfigurationSwitches[0].ruleType[1].status,
        rulesConfigurationCustomEdit: rulesConfigurationSwitches[1].ruleType[1].status,
        rulesConfigurationCustomDelete: rulesConfigurationSwitches[2].ruleType[1].status,
        rulesConfigurationCustomSearch: rulesConfigurationSwitches[3].ruleType[1].status,
        RulesConfigurationCustomActive: rulesConfigurationSwitches[4].ruleType[1].status
      },
    });
  }

  const handleClose = () => {
    setOpen(false);
  };
  const handleCodeMappingSwitchChange = (name, type, checked) => {
    const switchFinded = codeMappingSwitches.find(label => label.name === name);
    const switchStatusFinded = switchFinded.ruleType.find(label => label.type === type);
    switchStatusFinded.status = checked;
    const replaceSwitch = codeMappingSwitches.map(switchType => switchType.id !== switchFinded.id ? switchType : switchFinded);
    setCodeMappingSwitches(replaceSwitch);
  };
  const handleRuleMappingSwitchChange = (name, type, checked) => {
    const switchFinded = rulesConfigurationSwitches.find(label => label.name === name);
    const switchStatusFinded = switchFinded.ruleType.find(label => label.type === type);
    switchStatusFinded.status = checked;
    const replaceSwitch = rulesConfigurationSwitches.map(switchType => switchType.id !== switchFinded.id ? switchType : switchFinded);
    setRulesConfigurationSwitches(replaceSwitch);
  };

  // Enable the save button and show success message once role action permission gets updated
  useEffect(() => {
    if (dataRoleActionPermissionUpdate) {
      toast(transactionResponse(transactionMessages.moduleName, dataRoleActionPermissionUpdate.updateRoleActionPermission.status));
      setSaveDisabled(false);
    }
  }, [dataRoleActionPermissionUpdate]);
  // Retrieve the current role actions permissions 
  useEffect(() => {
    if (dataRolePermissions) {
      setCodeMappingSwitches(
        [
          { id: 1, name: 'Create', ruleType: [{ id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.CodeMappingEnterpriseCreate, type: 'Enterprise' }] },
          { id: 2, name: 'Edit', ruleType: [{ id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.CodeMappingEnterpriseEdit, type: 'Enterprise' }] },
          { id: 3, name: 'Delete', ruleType: [{ id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.CodeMappingEnterpriseDelete, type: 'Enterprise' }] },
          { id: 4, name: 'Search', ruleType: [{ id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.CodeMappingEnterpriseSearch, type: 'Enterprise' }] }
        ]
      );

      setRulesConfigurationSwitches(
        [
        {
          id: 1, name: 'Create', ruleType: 
          [
            { id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationEnterpriseCreate, type: 'Enterprise' },
            { id: 2, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationCustomCreate, type: 'Custom' }
          ]
        },
        {
          id: 2, name: 'Edit', ruleType: 
          [
            { id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationEnterpriseEdit, type: 'Enterprise' },
            { id: 2, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationCustomEdit, type: 'Custom' }
          ]
        },
        {
          id: 3, name: 'Delete', ruleType: 
          [
            { id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationEnterpriseDelete, type: 'Enterprise' },
            { id: 2, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationCustomDelete, type: 'Custom' }
          ]
        },
        {
          id: 4, name: 'Search', ruleType: 
          [
            { id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationEnterpriseSearch, type: 'Enterprise' },
            { id: 2, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationCustomSearch, type: 'Custom' }
          ]
        },
        {
          id: 5, name: 'Activate/Pause', ruleType: 
          [
            { id: 1, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationEnterpriseActive, type: 'Enterprise' },
            { id: 2, status: dataRolePermissions.roleActionPermissionByUserRole.RulesConfigurationCustomActive, type: 'Custom' }
          ]
        }
        ]
      );
    }
  }, [dataRolePermissions]);

  return (
    <Box className="admin-manage outer-container-box">
      <div className="admin-manage sub-header">
        <TableContainer className="manage-table role-permissions-container" component={Paper}>
          <AdminTable
            loading={isLoading}
            permission={codeMappingSwitches}
            label={CodeMappingLabels}
            handleSwitchChange={handleCodeMappingSwitchChange}
          />
          <AdminTable
            loading={isLoading}
            permission={rulesConfigurationSwitches}
            label={RuleConfigurationLabels}
            handleSwitchChange={handleRuleMappingSwitchChange}
          />
        </TableContainer>
        <div className="container-footer">
          <CustomButtons 
            handleClick={handleSave}
            name="Save"
            disabled={saveDisabled}
            loadingButton={saveDisabled}
            loading={isLoading}
          />
        </div>
        <ToastContainer hideProgressBar />
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <ModalDetail modalOptions={modalOptions} />
        </DialogContent>
      </Modal>
    </Box>
  );
};

export default RolePermissions